import { FRAMEWORKS, FRAMEWORKS_LABELS } from '../../../components/lets-form';

const labelsFramework = FRAMEWORKS
  .reduce((acc, framework, idx) => ({ ...acc, [framework]: FRAMEWORKS_LABELS[idx] }), {});

  export const labelFramework = framework => labelsFramework[framework];
